import { render, staticRenderFns } from "./StatsComp.vue?vue&type=template&id=5d8551c8&scoped=true"
import script from "./StatsComp.vue?vue&type=script&lang=js"
export * from "./StatsComp.vue?vue&type=script&lang=js"
import style0 from "./StatsComp.vue?vue&type=style&index=0&id=5d8551c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8551c8",
  null
  
)

export default component.exports